import axios from '@/api/request'

/**
 * BOSS 端认证（views/boss/login）接口定义
 * 账密登录 / 用户信息已联调真实后端（平台服务 API · BOSS·认证）；统一响应 { code, message, data, trace_id }。
 * 注：真实后端暂无 BOSS 短信验证码登录接口，sms 相关两个端点待后端提供后替换。
 */

// BOSS 账密登录 { account, password: sha256, captcha_id, captcha_code } → { access_token, refresh_token, user_id, expires_in, refresh_expires_in }
export const bossuserlogin = (params) => axios('post', '/api/boss/login', params)

// 获取图形验证码（YApi 1453 · BOSS·认证）入参 {} → { captcha_id, expires_in, image_base64, provider }
// 公开端点；image_base64 为 PNG base64（不含 data: 前缀）；验证码一次性、expires_in 秒内有效，校验即失效
export const bossCaptcha = () => axios('post', '/api/boss/captcha', {})

// 服务器配置（YApi 1461 · BOSS·认证）入参 {} → { captcha_enabled, captcha_provider, server_time, server_timestamp, tencent_captcha_appid }
// 公开端点；captcha_provider: image=数字图形 / tencent=腾讯防水墙 / none=未开启
// silent：开关属于可选兜底查询，失败不弹窗，由登录页 fail-close 隐藏验证码
export const bossServerConfig = () => axios('post', '/api/boss/server/config', {}, false, true)

// 当前登录用户信息（令牌鉴权，入参 {}）→ 个人基本信息 + 部门/角色/权限 node_keys
export const bossgetuser = (params) => axios('post', '/api/boss/profile', params)

// 修改密码（YApi 389 · BOSS·认证）{ old_password: sha256, new_password: sha256 } → { success }
// 校验旧密码；成功后该用户全部会话失效，需重新登录
export const bossPasswordUpdate = (params) => axios('post', '/api/boss/password/update', params)

// BOSS 登出（YApi 341 · BOSS·认证）→ { success }
// access_token 缺省取 Authorization 头（request 层已注入）；silent：失败不弹窗，由调用方继续本地清理
export const bossuserLogout = () => axios('post', '/api/boss/logout', {}, false, true)

// TODO(联调): 真实后端暂无 BOSS 短信登录接口，以下两个端点为旧 mock 路径，待后端提供后替换
// 发送手机验证码
export const bossuserSmsCode = (params) => axios('post', '/api/boss/sms-code', params)

// 手机号 + 验证码登录
export const bossuserloginByCode = (params) => axios('post', '/api/boss/login-by-code', params)
